import { Suspense } from 'react'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import { I18N_KEYS } from '@/i18n/keys'
import { router } from '@/router'
import i18n from '@/i18n'

function AppFallback() {
  return (
    <div className="grid min-h-screen place-items-center bg-slate-50 px-4 text-center text-slate-700">
      <p className="text-sm font-medium">{i18n.t(I18N_KEYS.app.loading)}</p>
    </div>
  )
}

export default function App() {
  const fallback = <AppFallback />

  return (
    <>
      <Suspense fallback={fallback}>
        <RouterProvider router={router} fallbackElement={fallback} />
      </Suspense>
      <Toaster richColors position="top-right" />
    </>
  )
}
